import { Action, configureStore, isPlain, ThunkAction } from "@reduxjs/toolkit";
import paginationReducer from "../pagination.slice";
import { onChatbotSlice } from "../chatbot.slice";
import { uiSlice } from "../uiState.slice";
import { categoriesSlice } from "../categories.slice";
import { chatSlice } from "../chat.slice";
import { imagesSlice } from "../images.slice";
import { intentSlice } from "../intent.slice";
import { sopSlice } from "../sop.slice";
import contextReducer from "../context.slice";
import { brainSlice } from "../brain.slice";
import { conversationsSlice } from "../conversations.slice";

const store = configureStore({
  reducer: {
    pagination: paginationReducer,
    context: contextReducer,
    chatbot: onChatbotSlice.reducer,
    ui: uiSlice.reducer,
    categories: categoriesSlice.reducer,
    chat: chatSlice.reducer,
    images: imagesSlice.reducer,
    intent: intentSlice.reducer,
    sop: sopSlice.reducer,
    brain: brainSlice.reducer,
    conversations: conversationsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        isSerializable: (value: any) =>
          value == null ||
          typeof value !== "object" ||
          isPlain(value) ||
          value instanceof Date,
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;

export default store;
